"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUploadStore = void 0;
const tslib_1 = require("tslib");
const controller_1 = require("@incodocs/react/controller");
const result_1 = (0, tslib_1.__importDefault)(require("lodash/result"));
const cloneDeep_1 = (0, tslib_1.__importDefault)(require("lodash/cloneDeep"));
const pick_1 = (0, tslib_1.__importDefault)(require("lodash/pick"));
const merge_1 = (0, tslib_1.__importDefault)(require("lodash/merge"));
class FileUploadStore extends controller_1.Store {
    constructor(initialFiles) {
        super({
            errors: [],
            uploads: initialFiles || [],
            statuses: {},
            widgetMinimised: false
        });
        this.fileUploadCompleteListeners = [];
        this.subscribeToFileUploadComplete = (listener) => {
            this.fileUploadCompleteListeners.push(listener);
            return () => this.unsubscribeFromFileUploadComplete(listener);
        };
        this.unsubscribeFromFileUploadComplete = (listener) => {
            this.fileUploadCompleteListeners.filter(f => f !== listener);
        };
        this.notifyOfFileUploadComplete = (upload) => {
            this.fileUploadCompleteListeners.forEach(listener => {
                listener(upload);
            });
        };
        this.addFiles = (upload) => {
            const newUploads = upload.map(u => this.addFile(u));
            return newUploads;
        };
        this.addFile = (upload) => {
            const defaultMeta = {
                meta: {
                    touched: false,
                    errors: [],
                    dirty: false
                }
            };
            const newUpload = (0, merge_1.default)(defaultMeta, upload);
            this.setState(state => (Object.assign(Object.assign({}, state), { uploads: [...state.uploads, newUpload] })));
            return newUpload;
        };
        this.removeFile = (name) => {
            this.setState(state => {
                const filesTokeep = state.uploads
                    .map(f => (f.name !== name ? f.name : null))
                    .filter(v => v !== null);
                const statuses = (0, pick_1.default)((0, cloneDeep_1.default)(state.statuses), filesTokeep);
                return Object.assign(Object.assign({}, state), { statuses, uploads: [...state.uploads.filter(f => f.name !== name)] });
            });
        };
        this.getFile = (name) => {
            return this.state.uploads.find(file => file.name === name);
        };
        this.getFileIndex = (name) => {
            return this.state.uploads.findIndex(file => file.name === name);
        };
        this.getFileStatus = (name) => {
            return (0, result_1.default)(this.state.statuses, name);
        };
    }
}
exports.FileUploadStore = FileUploadStore;
//# sourceMappingURL=FileUploadStore.js.map